import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? window.location.origin,
  plugins: [adminClient()],
});

export const { signIn, signOut, useSession } = authClient;
